<template>
  <div class="trade-type-box">
    <div class="trade-type-box-header">
      <p style="display: none;">{{ $t("trade.title") }}</p>
      <p class="link-btn" style="font-weight: 700">
        {{ $t("common.unit") }}
      </p>
    </div>
    <div class="trade-type-box-list">
      <van-cell-group>
        <van-cell
          v-for="(item, index) in safeDataLst"
          :key="index"
          @click="toChange(item)"
        >
          <template #title>
            <div class="name">
              {{ item.title.split("/")[0]
              }}<span>/{{ item.title.split("/")[1] }}</span>
            </div>
          </template>
          <template>
            <span
              :class="item.change.indexOf('+') != -1 ? 'data-up' : 'data-down'"
            >
              {{ item.close }}
            </span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "TradeTypeList",
  props: ["datalst"],
  computed: {
    safeDataLst() {
      return this.datalst || [];
    },
  },
  watch: {
    datalst() {
      
    },
  },
  data() {
    return {
      symbolinfo: {},
    };
  },
  methods: {
    toChange(item) {
      this.$emit("change-item-event", item);
    },
  },
};
</script>

<style>
</style>
